module.exports = __webpack_public_path__ + "static/bg_sections-9a1f2af92fd6cbbaa6d20a41ee0bafec.svg";